import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
import _createForOfIteratorHelper from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList } from '@/api/PMS/chargeManagement/chargingParameterSetting/chargingStandardSetting/chargingStandardSetting';
import { fetchList as fetchChargeList } from '@/api/PMS/chargeManagement/chargingParameterSetting/definitionChargingItems/definitionChargingItems/definitionChargingItems';
import { selectPmsTreeWithArea } from '@/api/PMS/baseInformation/meterManager';
import customerDetail from '@/views/PMS/baseInformation/customer/detail';
import contractDetail from '../contractList/contractDetail';
import { formatJson } from '@/utils/index';
import waves from '@/directive/waves';
export default {
  components: {
    customerDetail: customerDetail,
    contractDetail: contractDetail
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      activePane: 'first',
      listQuery: {
        page: 1,
        limit: 10
      },
      title: '',
      searchId: [],
      contractId: '',
      customerId: '',
      total: 0,
      listLoading: false,
      dialogCustomerFormVisible: false,
      dialogContractFormVisible: false,
      dates: [],
      projectOption: [],
      options: [],
      cascaderItem: [],
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      }
    };
  },
  watch: {
    searchId: function searchId(val) {
      this.listQuery.id = val[val.length - 1];
    },
    deep: true
  },
  created: function created() {
    this.options = [];
    this.getList();
    this.loadMenuTree();
    this.loadProjectOption();
  },
  methods: {
    getList: function getList() {
      var _this = this;

      if (this.dates) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = '';
        this.listQuery.endDate = '';
      }

      this.listLoading = true;
      fetchList(this.listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.data.data;
        _this.total = res.data.total;
      });
    },
    handleReset: function handleReset() {
      this.listQuery = {
        page: 1,
        limit: 10
      };
    },
    handleFilter: function handleFilter() {
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    loadProjectOption: function loadProjectOption() {
      var _this2 = this;

      fetchChargeList({}).then(function (r) {
        _this2.projectOption = r.data.data;
      });
    },
    handleClick: function handleClick() {},
    getcontractDetail: function getcontractDetail(id) {
      this.title = '账单详情';
      this.contractId = id;
      this.dialogContractFormVisible = true;
    },
    getCustomerDetail: function getCustomerDetail(customerId) {
      this.dialogCustomerFormVisible = true;
      this.customerId = customerId;
      this.title = '客户详情';
    },
    loadMenuTree: function loadMenuTree() {
      var _this3 = this;

      var treeQuery = {
        flag: 1
      };
      selectPmsTreeWithArea(treeQuery).then(function (response) {
        _this3.options = response.data.data;
      });
    },
    handTreeSelect: function handTreeSelect(val) {
      this.cascaderItem = [];
      this.getCascaderItem(this.searchId, this.options); // 如果当前没有数据了，就删除掉dataType

      if (this.cascaderItem.length <= 0) {
        delete this.listQuery.dataType;
      } else {
        this.listQuery.dataType = this.cascaderItem[this.cascaderItem.length - 1].flag;
      }
    },
    getCascaderItem: function getCascaderItem(val, opt) {
      var _this4 = this;

      return val.map(function (value, index, arr) {
        var _iterator = _createForOfIteratorHelper(opt),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;

            if (item.id === value) {
              opt = item.pmsTree;

              _this4.cascaderItem.push(item);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    },
    // 导出汇总
    handleExportTotal: function handleExportTotal() {
      var _this5 = this;

      var exportList = [];
      fetchList(this.exportQuery).then(function (res) {
        exportList = res.data.data;

        _this5.$confirm('你确定是要导出这些未出账单, 是否继续?', '提示').then(function () {
          if (exportList !== null && exportList.length > 0) {
            _this5.downloadLoading = true;
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require('@/vendor/Export2Excel'));
            }).then(function (excel) {
              var tHeader = ['楼栋', '房间代码', '客户名称', '项目名称', '收费标准', '开始时间', '结束时间', '单价', '单价单位', '仪表名称', '用量', '上次读数', '本次读数', '建筑面积', '使用面积', '金额', '打折金额', '折扣率'];
              var filterVal = ['buildingName', 'houseCode', 'customerName', 'chargeItemName', 'chargeStandardName', 'beginDate', 'endDate', 'price', 'priceUnitName', 'meterName', 'meterUse', 'lastReas', 'currentRead', 'houseArea', 'houseUseArea', 'receivableAmount', 'reductionAmount', 'discountRate'];
              var data = formatJson(filterVal, exportList);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: '未出账单记录',
                autoWidth: true,
                bookType: 'xlsx'
              });
              _this5.downloadLoading = false;
            });
          } else {
            _this5.Alert({
              alertType: 'error',
              message: '暂无数据，无法导出!'
            });
          }
        });
      });
    },
    // 导出明细
    handleExportDetail: function handleExportDetail() {
      var _this6 = this;

      var exportList = [];
      fetchList(this.exportQuery).then(function (res) {
        exportList = res.data.data;

        _this6.$confirm('你确定是要导出这些未出账单, 是否继续?', '提示').then(function () {
          if (exportList !== null && exportList.length > 0) {
            _this6.downloadLoading = true;
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require('@/vendor/Export2Excel'));
            }).then(function (excel) {
              var tHeader = ['楼栋', '房间代码', '客户名称', '项目名称', '收费标准', '开始时间', '结束时间', '单价', '单价单位', '仪表名称', '用量', '上次读数', '本次读数', '建筑面积', '使用面积', '金额', '打折金额', '折扣率'];
              var filterVal = ['buildingName', 'houseCode', 'customerName', 'chargeItemName', 'chargeStandardName', 'beginDate', 'endDate', 'price', 'priceUnitName', 'meterName', 'meterUse', 'lastReas', 'currentRead', 'houseArea', 'houseUseArea', 'receivableAmount', 'reductionAmount', 'discountRate'];
              var data = formatJson(filterVal, exportList);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: '未出账单记录',
                autoWidth: true,
                bookType: 'xlsx'
              });
              _this6.downloadLoading = false;
            });
          } else {
            _this6.Alert({
              alertType: 'error',
              message: '暂无数据，无法导出!'
            });
          }
        });
      });
    },
    handCancle: function handCancle() {
      this.dialogCustomerFormVisible = false;
      this.dialogContractFormVisible = false;
    }
  }
};